import { Permission } from '@weave/schema-gen-ts/dist/shared/waccess/acls.pb';
import { GetPermittedLocationsStrategy, getPermittedLocations } from './get-permitted-locations';

export const getPaymentsBillingManagerLocations = ({
  locationIds,
  strategy = 'all',
}: {
  locationIds: string[];
  strategy?: GetPermittedLocationsStrategy;
}) => {
  const { permittedLocations: paymentsBillingManagerLocations, hasPermission } = getPermittedLocations(
    locationIds,
    [
      Permission.BILLING_INFORMATION_READ,
      Permission.BILLING_INFORMATION_WRITE,
      Permission.PAYMENTS_REFUNDS,
      Permission.PAYMENTS_EXPORTS,
      Permission.PAYMENTS_EXPRESS_DASHBOARD,
    ],
    { strategy }
  );

  return { paymentsBillingManagerLocations, isPaymentsBillingManager: hasPermission };
};
